const GET_PACKAGE_LIST_DATA = 'GET_PACKAGE_LIST_DATA';
const GET_PACKAGE_DATA_LOADING = 'GET_PACKAGE_DATA_LOADING';

// --- Subscription Page Sections ---
const GET_SUBSCRIPTION_HERO_LOADING = 'GET_SUBSCRIPTION_HERO_LOADING';
const GET_SUBSCRIPTION_HERO_DATA = 'GET_SUBSCRIPTION_HERO_DATA';
const GET_SUBSCRIPTION_FEATURE_LOADING = 'GET_SUBSCRIPTION_FEATURE_LOADING';
const GET_SUBSCRIPTION_FEATURE_DATA = 'GET_SUBSCRIPTION_FEATURE_DATA';
const GET_SUBSCRIPTION_OFFER_LOADING = 'GET_SUBSCRIPTION_OFFER_LOADING';
const GET_SUBSCRIPTION_OFFER_DATA = 'GET_SUBSCRIPTION_OFFER_DATA';

export const TYPES_PACKAGE = {
  GET_PACKAGE_LIST_DATA, GET_PACKAGE_DATA_LOADING,
  GET_SUBSCRIPTION_HERO_LOADING, GET_SUBSCRIPTION_HERO_DATA,
  GET_SUBSCRIPTION_FEATURE_LOADING, GET_SUBSCRIPTION_FEATURE_DATA,
  GET_SUBSCRIPTION_OFFER_LOADING, GET_SUBSCRIPTION_OFFER_DATA,
};
